import { render, staticRenderFns } from "./testapproved.vue?vue&type=template&id=719c0790"
import script from "./testapproved.vue?vue&type=script&lang=js"
export * from "./testapproved.vue?vue&type=script&lang=js"
import style0 from "./testapproved.vue?vue&type=style&index=0&id=719c0790&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports